// ─── HTML Sanitizer ─────────────────────────────────────────────────────────
// Wraps DOMPurify for safe use of dangerouslySetInnerHTML with server content.
// Falls back to basic sanitization if DOMPurify is unavailable.

let DOMPurify = null;
try {
  DOMPurify = require('dompurify');
} catch (e) {
  // DOMPurify not available — use basic fallback
}

/**
 * Sanitize HTML string for safe rendering via dangerouslySetInnerHTML.
 * Strips script tags, event handlers, and other XSS vectors.
 */
export function sanitizeHTML(dirty) {
  if (!dirty || typeof dirty !== 'string') return '';
  
  if (DOMPurify) {
    return DOMPurify.sanitize(dirty, {
      ALLOWED_TAGS: [
        'b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div', 'img',
        'table', 'thead', 'tbody', 'tr', 'td', 'th', 'code', 'pre',
        'blockquote', 'hr', 'sub', 'sup', 'u', 's', 'del', 'ins',
      ],
      ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'id', 'style', 'target', 'rel'],
      ALLOW_DATA_ATTR: false,
    });
  }
  
  // Basic fallback sanitization
  return dirty
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/on\w+\s*=\s*["'][^"']*["']/gi, '')
    .replace(/on\w+\s*=\s*[^\s>]*/gi, '')
    .replace(/javascript\s*:/gi, '')
    .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '');
}

export default sanitizeHTML;
